import { Action } from '@ngrx/store';
import { TechnicalError } from '@dch/products-business-logic';
import { SplitUnbilledBalance } from 'src/app/details/mobile/level-two/split-bill-detail/split-bill.model';

export const GET_SPLIT_UNBILLED_BALANCE = 'GET_SPLIT_UNBILLED_BALANCE';
export const GET_SPLIT_UNBILLED_BALANCE_SUCCESS =
  'GET_SPLIT_UNBILLED_BALANCE_SUCCESS';
export const GET_SPLIT_UNBILLED_BALANCE_FAILED =
  'GET_SPLIT_UNBILLED_BALANCE_FAILED';

export class GetSplitUnbilledBalance implements Action {
  type = GET_SPLIT_UNBILLED_BALANCE;

  constructor(public payload?: any) {}
}

export class GetSplitUnbilledBalanceSuccess implements Action {
  type = GET_SPLIT_UNBILLED_BALANCE_SUCCESS;

  constructor(public payload: SplitUnbilledBalance) {}
}

export class GetSplitUnbilledBalanceFailed implements Action {
  type = GET_SPLIT_UNBILLED_BALANCE_FAILED;

  constructor(public payload: TechnicalError) {}
}

export type Actions =
  | GetSplitUnbilledBalance
  | GetSplitUnbilledBalanceFailed
  | GetSplitUnbilledBalanceSuccess;
